"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _RelatedAccessoriesComponent = _interopRequireDefault(require("./RelatedAccessoriesComponent"));

var _CompatibilityComponent = _interopRequireDefault(require("./CompatibilityComponent"));

var _SupportMaterialsComponent = _interopRequireDefault(require("./SupportMaterialsComponent"));

var _AppsComponent = _interopRequireDefault(require("./AppsComponent"));

var _utils = require("../../../../../configuration/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DetailsTabComponent = function DetailsTabComponent(_ref) {
  var devices = _ref.devices;
  var tabs = ['apps', 'relatedAccessories', 'bluetooth', 'marketingMaterials'];

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      sliderKey = _useState2[0],
      setSliderKey = _useState2[1];

  var activeOnLoad = 'relatedAccessories';
  var dictionary = (0, _reactRedux.useSelector)(function (state) {
    return state.dictionary;
  });
  var product = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedProduct;
  });
  var relatedAccessories = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedProduct.relatedAccessories;
  });

  var findAvaliableTab = function findAvaliableTab() {
    var setActive;
    tabs.map(function (tabName) {
      if (product[tabName] && (product[tabName].length > 0 || typeof product[tabName] === 'boolean' && product[tabName])) {
        setActive = tabName;
        return;
      }
    });
    return setActive;
  };

  (0, _react.useEffect)(function () {
    var tabsContainer = document.getElementsByClassName('single-tab');
    var detailsTabSection = document.getElementsByClassName('details-tab-section');

    if (tabsContainer.length === 0) {
      detailsTabSection[0].style.display = 'none';
    }
  }, [product]);
  (0, _react.useEffect)(function () {
    if (relatedAccessories && relatedAccessories.length) {
      var key = sliderKey + 1;
      setSliderKey(key);
      setTab('relatedAccessories');
    } else {
      setTab(findAvaliableTab());
    }
  }, [relatedAccessories, product]);

  var _useState3 = (0, _react.useState)(product[activeOnLoad] && product[activeOnLoad].length > 0 ? activeOnLoad : findAvaliableTab()),
      _useState4 = _slicedToArray(_useState3, 2),
      currentTab = _useState4[0],
      setTab = _useState4[1];

  var changeTab = function changeTab(current) {
    setTab(current);
    (0, _utils.sendDataLayerEvent)('Tab', current === 'bluetooth' ? 'Compatibility' : current || 'none');
  };

  var detailsTabSlider = {
    dots: false,
    infinite: false,
    centerMode: false,
    slidesToShow: tabs.length,
    variableWidth: true,
    arrows: false,
    slidesToScroll: 0,
    responsive: [{
      breakpoint: 500,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true
      }
    }, {
      breakpoint: 400,
      settings: {
        slidesToShow: 2.3,
        slidesToScroll: 1,
        arrows: true
      }
    }]
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tabs-container"
  }, tabs && /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], _extends({}, detailsTabSlider, {
    key: sliderKey
  }), tabs.map(function (tabName, index) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: index
    }, product[tabName] && product[tabName] !== '0' && (product[tabName].length > 0 || typeof product[tabName] === 'boolean' && product[tabName]) && /*#__PURE__*/_react["default"].createElement("a", {
      className: currentTab === tabName ? "single-tab active" : "single-tab",
      "aria-expanded": currentTab === tabName ? 'true' : 'false',
      "data-content": tabName,
      tabIndex: 5,
      key: index,
      onClick: function onClick(e) {
        return changeTab(tabName === currentTab ? null : tabName) && e.preventDefault();
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      dangerouslySetInnerHTML: {
        __html: dictionary.tabDictionary[tabName] ? dictionary.tabDictionary[tabName] : '&nbbsp;'
      },
      className: "svg-icon"
    }), /*#__PURE__*/_react["default"].createElement("span", {
      dangerouslySetInnerHTML: {
        __html: dictionary[tabName] ? dictionary[tabName].toUpperCase() : ''
      }
    })));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "tab__content"
  }, /*#__PURE__*/_react["default"].createElement(_AppsComponent["default"], {
    currentTab: currentTab,
    tabName: tabs[0]
  }), /*#__PURE__*/_react["default"].createElement(_RelatedAccessoriesComponent["default"], {
    currentTab: currentTab,
    tabName: tabs[1]
  }), /*#__PURE__*/_react["default"].createElement(_CompatibilityComponent["default"], {
    currentTab: currentTab,
    tabName: tabs[2],
    devices: devices
  }), /*#__PURE__*/_react["default"].createElement(_SupportMaterialsComponent["default"], {
    currentTab: currentTab,
    tabName: tabs[3]
  })));
};

var _default = DetailsTabComponent;
exports["default"] = _default;